/* @flow */
import * as React from 'react';
import { Link } from 'react-router-dom';

import { inject, observer } from 'mobx-react';
import { Trans, translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import { browserHistory } from 'services/ServiceRegistry';

import { ElectroButton } from 'components/ExtendedUiElements/customized.js';

import type { TypeWithEmailModel } from 'models/AccountModels';

import CentralForm from 'components/CentralForm/CentralForm.js';

import styles from 'common-scss/formstyles.module.scss';

//MagicLink.js

function MagicLinkP({ t, emailModel }: TypeWithEmailModel & TranslatorProps): React.Element<*> {
  return browserHistory.location.state && !browserHistory.location.state.success ? (
    <CentralForm>
      <h1>{t('general:accounts.messages.magic_link_failed')}</h1>
      <p>{t(`${browserHistory.location.state.message}`)}</p>
      <Link to="/login" className={styles['button-anchor']}>
        <ElectroButton label={t('general:accounts.return_to_sign_in')} color="primary" />
      </Link>
    </CentralForm>
  ) : (
    <CentralForm>
      <h1>{t('general:accounts.check_your_email')}</h1>
      <Trans i18nKey="general:accounts.messages.magic_link_sent_to" parent="p">
        <strong>{emailModel.email}</strong>
      </Trans>
      <Link to="/login" className={styles['button-anchor']}>
        <ElectroButton label={t('general:accounts.return_to_sign_in')} color="primary" />
      </Link>
    </CentralForm>
  );
}

const MagicLink: (props: TypeWithEmailModel) => React.Element<*> = translate()(
  inject('emailModel')(observer(MagicLinkP))
);

export default MagicLink;
